import React from 'react';
import './V1CTAButton.css';

interface V1CTAButtonProps {
  variant?: 'primary' | 'secondary' | 'sticky';
  size?: 'small' | 'medium' | 'large';
  urgency?: boolean;
  theme: 'premium' | 'energetic';
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}

const V1CTAButton: React.FC<V1CTAButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  urgency = false,
  theme,
  children,
  onClick,
  className = ''
}) => {
  const classes = [
    'v1-cta-button',
    `v1-btn-${variant}`,
    `v1-btn-${size}`,
    className
  ].join(' ');

  return (
    <div className="v1-cta-wrapper">
      <button
        className={classes}
        onClick={onClick}
        data-theme={theme}
      >
        {children}
      </button>
      {urgency && (
        <div className="v1-urgency-badge">
          ⚡ Tylko 3 miejsca pozostały
        </div>
      )}
    </div>
  );
};

export default V1CTAButton;
